import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { brand } from '../../shared-theme/brand';

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'split' | 'center';
}

// Shared section header. Default is an editorial split: heading on the left,
// supporting line on the right, sitting on a hairline. Centered is reserved
// for the closing CTA so the page doesn't read as a stack of identical blocks.
export default function SectionHeader({ title, subtitle, align = 'split' }: SectionHeaderProps) {
  const centered = align === 'center';
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: centered || !subtitle ? '1fr' : '1.1fr 0.9fr' },
        alignItems: 'end',
        columnGap: 8,
        rowGap: 2,
        textAlign: centered ? 'center' : 'left',
        mb: { xs: 5, md: 7 },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: '2rem', md: '2.75rem' },
          fontWeight: 500,
          color: brand.brown,
          letterSpacing: '-0.025em',
          lineHeight: 1.12,
          maxWidth: centered ? 720 : 620,
          mx: centered ? 'auto' : 0,
          textWrap: 'balance',
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: brand.taupe,
            maxWidth: 520,
            mx: centered ? 'auto' : 0,
            fontSize: { xs: '1rem', md: '1.075rem' },
            lineHeight: 1.65,
            textWrap: 'pretty',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
